import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWishlist } from '../context/WishlistContext';
import { getFullImageUrl } from '../services/api';
import './Wishlist.css';

const Wishlist: React.FC = () => {
  const navigate = useNavigate();
  const { wishlistItems, removeFromWishlist } = useWishlist();

  const handleViewProduct = (productId: string) => {
    navigate(`/product/${productId}`);
  };

  const handleRemove = (productId: string, productName: string) => {
    if (window.confirm(`Remove "${productName}" from your wishlist?`)) {
      removeFromWishlist(productId);
    }
  };

  if (wishlistItems.length === 0) {
    return (
      <div className="wishlist-page">
        <div className="wishlist-header">
          <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
          <h1>My Wishlist ❤️</h1>
        </div>
        <div className="empty-wishlist">
          <div className="empty-icon">❤️</div>
          <h2>Your wishlist is empty</h2>
          <p>Save items you love by clicking the heart icon on any product</p>
          <button onClick={() => navigate('/products')} className="shop-now-btn">
            Start Shopping
          </button>
        </div>
      </div>
    );
  }
 
  return (
    <div className="wishlist-page">
      <div className="wishlist-header">
        <button className="back-btn" onClick={() => navigate(-1)}>← Back</button>
        <h1>My Wishlist ❤️</h1>
        <span className="wishlist-count">{wishlistItems.length} items</span>
      </div>

      <div className="wishlist-grid">
        {wishlistItems.map((item) => (
          <div key={item._id} className="wishlist-card">
            <div className="wishlist-image">
              <img 
                src={getFullImageUrl(item.image)} 
                alt={item.name}
                onClick={() => handleViewProduct(item._id)}
              />
              <button 
                className="remove-btn"
                onClick={() => handleRemove(item._id, item.name)}
                title="Remove from wishlist"
              >
                ❌
              </button>
            </div>
            <div className="wishlist-info">
              <h3 onClick={() => handleViewProduct(item._id)}>{item.name}</h3>
              <p className="category">{item.category}</p>
              <p className="price">₦{item.price.toLocaleString()}</p>
              <button 
                className="view-product-btn"
                onClick={() => handleViewProduct(item._id)}
              >
                View Product →
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlist;